export default function headerComponent(showButtonOne, showButtonTwo) {
  return {
    open: false,
    stuck: false,
    top: true,
    lastScrollY: 0,
    showButtonOne: showButtonOne,
    showButtonTwo: showButtonTwo,
    isButtonOneLinkOpen: false,
    isButtonTwoLinkOpen: false,
    defaultNavClass: 'light',

    init() {
      window.addEventListener('scroll', this.handleScroll.bind(this));
      this.initIntersectionObserver();

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      setTimeout(this.setHeaderHeight, 100);

      if (!this.$store.header) {
        this.$store.header = {
          open: this.open,
          toggle: this.toggleNav.bind(this),
          enableScroll: this.enableScroll.bind(this),
          disableScroll: this.disableScroll.bind(this),
        };
      }
      this.applyDefaultNavClass();
    },

    handleScroll() {
      const currentScrollY = window.scrollY;
      const threshold = 10;

      // Scrolling down
      if (currentScrollY > this.lastScrollY + threshold) {
        if (!this.stuck) {
          this.stuck = true;
          this.$refs.header.classList.remove('dark');
          this.$refs.header.classList.add('light');
        }
      } 
      // Scrolling up
      else if (currentScrollY < this.lastScrollY - threshold) {
        if (this.stuck) {
          this.stuck = false;
          this.$refs.header.classList.remove('light');
          this.$refs.header.classList.add('dark');
          this.toggleButtonClass('btn-dark', 'btn-light');
        }
      }

      // At the top of the page
      if (currentScrollY === 0) {
        if (!this.top) {
          this.top = true;
          this.applyDefaultNavClass();
        }
      } else {
        if (this.top) {
          this.top = false;
        }
      }

      this.lastScrollY = currentScrollY;
      setTimeout(this.setHeaderHeight, 100);
    },

    initIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        let hasActiveClass = false;

        entries.forEach((entry) => {
          const dataAttribute = entry.target.getAttribute('data-nav-class');
          if (entry.isIntersecting) {
            hasActiveClass = true;
            if (dataAttribute) {
              this.$refs.header.classList.add(dataAttribute);
              if (dataAttribute === 'beige') {
                this.toggleButtonClass('btn-light', 'btn-dark');
              }
            }
          } else {
            if (dataAttribute) {
              this.$refs.header.classList.remove(dataAttribute);
              if (dataAttribute === 'dark') {
                this.toggleButtonClass('btn-dark', 'btn-light');
              }
            }
          }
        });

        if (!hasActiveClass) {
          this.applyDefaultNavClass();
        }
      });

      document.querySelectorAll('[data-nav-class]').forEach((el) => {
        observer.observe(el);
      });
    },

    toggleButtonClass(removeClass, addClass) {
      const buttons = this.$refs.header.querySelectorAll('.btn-light, .btn-dark');
      buttons.forEach((button) => {
        button.classList.remove(removeClass);
        button.classList.add(addClass);
      });
    },

    setHeaderHeight() {
      setTimeout(() => {
        const header = document.querySelector('#site-header');
        if (header) {
          document.body.style.setProperty('--header-height', getComputedStyle(header).height);
        }
      }, 100);
    },

    toggleNav() {
      this.open = !this.open;
      this.$store.header.open = this.open;
      if (this.open) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },

    enableScroll() {
      document.body.style.overflow = '';
    },

    disableScroll() {
      document.body.style.overflow = 'hidden';
    },

    applyDefaultNavClass() {
      const header = this.$refs.header;
      if (header) {
        if (header.classList.contains('beige')) {
          this.toggleButtonClass('btn-light', 'btn-dark');
        }
        header.classList.remove('dark', 'light'); 
        header.classList.add(this.defaultNavClass);

      }
    },
  };
}